export default {"src":"/_next/static/media/category.36de7360.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};